module.exports = __webpack_public_path__ + "static/media/8792.1093a605.png";